var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 13.4199V3.61992L5.74888 6.49604L4.51921 5.23079L9.5 0.25L14.4808 5.23079L13.2511 6.49604L10.375 3.61992V13.4199H8.625ZM2.85904 17.75C2.26968 17.75 1.77083 17.5458 1.3625 17.1375C0.954167 16.7292 0.75 16.2303 0.75 15.641V12.4775H2.5V15.641C2.5 15.7308 2.53743 15.813 2.61229 15.8877C2.68696 15.9626 2.76921 16 2.85904 16H16.141C16.2308 16 16.313 15.9626 16.3877 15.8877C16.4626 15.813 16.5 15.7308 16.5 15.641V12.4775H18.25V15.641C18.25 16.2303 18.0458 16.7292 17.6375 17.1375C17.2292 17.5458 16.7303 17.75 16.141 17.75H2.85904Z",
    fill: "#0094FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.d040861e80197d63aa296333b347b5e7.svg";
export { ForwardRef as ReactComponent };